<template>
  <div class="box mt-5">
    <h1 class="title is-2 has-text-weight-medium has-text-centered">Quiénes Somos</h1>

    <!-- Director -->
    <div class="rows" v-if="verCargo(director)">
      <div class="row">
        <div class="columns">
          <div class="column is-centered">
            <div class="box">
              <div class="columns is-left">
                <div class="column is-2 is-left" style="width:200px">
                  <div style="position:relative; display:inline-flex;">
                    <div style="cursor:pointer;" @click="redirect(director.id)">
                      <b-image :src="getPhotoUrl(director)" alt="Foto de perfil" style="max-width:150px; height:150px;" :rounded="true"></b-image>
                    </div>
                    <b-button
                      v-if="canEditAuthorities && director.id"
                      style="position:absolute; bottom:4px; right:4px;"
                      size="is-small" type="is-info" rounded icon-left="camera"
                      @click.stop="abrirModalFoto(director)"
                    />
                  </div>
                </div>
                <div class="column is-left">
                  <p class="title is-6" style="text-align:left; color:#A2A9AD;">{{director.cargo}}</p>
                  <h4 class="subtitle is-5" style="text-align:left; color:#EF7D00;">{{director.nombre || "Sin asignar"}}</h4>
                  <template v-if="director.correo">
                    <h5 class="title is-6" style="text-align:left; color:#A2A9AD;">Correo Electrónico</h5>
                    <h5 class="subtitle is-6" style="text-align:left; color:#A2A9AD; word-break:break-all;">{{director.correo}}</h5>
                  </template>
                  <div v-if="canEditAuthorities" class="mt-2">
                    <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion(director)">Editar</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Subdirectores docencia e inv_des -->
    <div class="rows" v-if="(subdirectores.docencia && subdirectores.docencia.id != null) || (subdirectores.inv_des && subdirectores.inv_des.id != null)">
      <div class="row">
        <div class="columns">
          <div class="column" v-if="subdirectores.docencia && subdirectores.docencia.id != null">
            <div class="box">
              <div class="columns is-left">
                <div class="column is-2 is-left" style="width:200px">
                  <div style="position:relative; display:inline-flex;">
                    <div style="cursor:pointer;" @click="redirect(subdirectores.docencia.id)">
                      <b-image :src="getPhotoUrl(subdirectores.docencia)" alt="Foto de perfil" style="max-width:150px; height:150px;" :rounded="true"></b-image>
                    </div>
                    <b-button
                      v-if="canEditAuthorities && subdirectores.docencia.id"
                      style="position:absolute; bottom:4px; right:4px;"
                      size="is-small" type="is-info" rounded icon-left="camera"
                      @click.stop="abrirModalFoto(subdirectores.docencia)"
                    />
                  </div>
                </div>
                <div class="column is-left">
                  <p class="title is-6" style="text-align:left; color:#A2A9AD;">{{subdirectores.docencia.cargo}}</p>
                  <h4 class="subtitle is-5" style="text-align:left; color:#EF7D00;">{{subdirectores.docencia.nombre}}</h4>
                  <h5 class="title is-6" style="text-align:left; color:#A2A9AD;">Correo Electrónico</h5>
                  <h5 class="subtitle is-6" style="text-align:left; color:#A2A9AD; word-break:break-all;">{{subdirectores.docencia.correo}}</h5>
                  <div v-if="canEditAuthorities" class="mt-2">
                    <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion(subdirectores.docencia)">Editar</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column" v-if="subdirectores.inv_des && subdirectores.inv_des.id != null">
            <div class="box">
              <div class="columns is-left">
                <div class="column is-2 is-left" style="width:200px">
                  <div style="position:relative; display:inline-flex;">
                    <div style="cursor:pointer;" @click="redirect(subdirectores.inv_des.id)">
                      <b-image :src="getPhotoUrl(subdirectores.inv_des)" alt="Foto de perfil" style="max-width:150px; height:150px;" :rounded="true"></b-image>
                    </div>
                    <b-button
                      v-if="canEditAuthorities && subdirectores.inv_des.id"
                      style="position:absolute; bottom:4px; right:4px;"
                      size="is-small" type="is-info" rounded icon-left="camera"
                      @click.stop="abrirModalFoto(subdirectores.inv_des)"
                    />
                  </div>
                </div>
                <div class="column is-left">
                  <p class="title is-6" style="text-align:left; color:#A2A9AD;">{{subdirectores.inv_des.cargo}}</p>
                  <h4 class="subtitle is-5" style="text-align:left; color:#EF7D00;">{{subdirectores.inv_des.nombre}}</h4>
                  <h5 class="title is-6" style="text-align:left; color:#A2A9AD;">Correo Electrónico</h5>
                  <h5 class="subtitle is-6" style="text-align:left; color:#A2A9AD; word-break:break-all;">{{subdirectores.inv_des.correo}}</h5>
                  <div v-if="canEditAuthorities" class="mt-2">
                    <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion(subdirectores.inv_des)">Editar</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Subdirector VIME -->
    <div class="rows" v-if="subdirectores.vime && subdirectores.vime.id != null">
      <div class="row">
        <div class="columns">
          <div class="column">
            <div class="box">
              <div class="columns is-left">
                <div class="column is-2 is-left" style="width:200px">
                  <div style="position:relative; display:inline-flex;">
                    <div style="cursor:pointer;" @click="redirect(subdirectores.vime.id)">
                      <b-image :src="getPhotoUrl(subdirectores.vime)" alt="Foto de perfil" style="max-width:150px; height:150px;" :rounded="true"></b-image>
                    </div>
                    <b-button
                      v-if="canEditAuthorities && subdirectores.vime.id"
                      style="position:absolute; bottom:4px; right:4px;"
                      size="is-small" type="is-info" rounded icon-left="camera"
                      @click.stop="abrirModalFoto(subdirectores.vime)"
                    />
                  </div>
                </div>
                <div class="column is-left">
                  <p class="title is-6" style="text-align:left; color:#A2A9AD;">{{subdirectores.vime.cargo}}</p>
                  <h4 class="subtitle is-5" style="text-align:left; color:#EF7D00;">{{subdirectores.vime.nombre}}</h4>
                  <h5 class="title is-6" style="text-align:left; color:#A2A9AD;">Correo Electrónico</h5>
                  <h5 class="subtitle is-6" style="text-align:left; color:#A2A9AD; word-break:break-all;">{{subdirectores.vime.correo}}</h5>
                  <div v-if="canEditAuthorities" class="mt-2">
                    <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion(subdirectores.vime)">Editar</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Jefes de carrera (de a 2 por fila) -->
    <div class="rows">
      <div class="row" v-for="(object, i) in jefes_carrera" :key="i">
        <div class="columns" v-if="i % 2 === 0">
          <div class="column" v-if="jefes_carrera[i] && jefes_carrera[i].id != null">
            <div class="box">
              <div class="columns is-left">
                <div class="column is-2 is-left" style="width:200px">
                  <div style="position:relative; display:inline-flex;">
                    <div style="cursor:pointer;" @click="redirect(jefes_carrera[i].id)">
                      <b-image :src="getPhotoUrl(jefes_carrera[i])" alt="Foto de perfil" style="max-width:150px; height:150px;" :rounded="true"></b-image>
                    </div>
                    <b-button
                      v-if="canEditAuthorities && jefes_carrera[i].id"
                      style="position:absolute; bottom:4px; right:4px;"
                      size="is-small" type="is-info" rounded icon-left="camera"
                      @click.stop="abrirModalFoto(jefes_carrera[i])"
                    />
                  </div>
                </div>
                <div class="column is-left">
                  <p class="title is-6" style="text-align:left; color:#A2A9AD;">{{jefes_carrera[i].cargo}}</p>
                  <h4 class="subtitle is-5" style="text-align:left; color:#EF7D00;">{{jefes_carrera[i].nombre}}</h4>
                  <h5 class="title is-6" style="text-align:left; color:#A2A9AD;">Correo Electrónico</h5>
                  <h5 class="subtitle is-6" style="text-align:left; color:#A2A9AD; word-break:break-all;">{{jefes_carrera[i].correo}}</h5>
                  <div v-if="canEditAuthorities" class="mt-2">
                    <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion(jefes_carrera[i])">Editar</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column" v-if="i+1 < jefes_carrera.length && jefes_carrera[i+1] && jefes_carrera[i+1].id != null">
            <div class="box">
              <div class="columns is-left">
                <div class="column is-2 is-left" style="width:200px">
                  <div style="position:relative; display:inline-flex;">
                    <div style="cursor:pointer;" @click="redirect(jefes_carrera[i+1].id)">
                      <b-image :src="getPhotoUrl(jefes_carrera[i+1])" alt="Foto de perfil" style="max-width:150px; height:150px;" :rounded="true"></b-image>
                    </div>
                    <b-button
                      v-if="canEditAuthorities && jefes_carrera[i+1].id"
                      style="position:absolute; bottom:4px; right:4px;"
                      size="is-small" type="is-info" rounded icon-left="camera"
                      @click.stop="abrirModalFoto(jefes_carrera[i+1])"
                    />
                  </div>
                </div>
                <div class="column is-left">
                  <p class="title is-6" style="text-align:left; color:#A2A9AD;">{{jefes_carrera[i+1].cargo}}</p>
                  <h4 class="subtitle is-5" style="text-align:left; color:#EF7D00;">{{jefes_carrera[i+1].nombre}}</h4>
                  <h5 class="title is-6" style="text-align:left; color:#A2A9AD;">Correo Electrónico</h5>
                  <h5 class="subtitle is-6" style="text-align:left; color:#A2A9AD; word-break:break-all;">{{jefes_carrera[i+1].correo}}</h5>
                  <div v-if="canEditAuthorities" class="mt-2">
                    <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion(jefes_carrera[i+1])">Editar</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Jefe Administrativo -->
    <div class="rows" v-if="jefe_admin.id != null">
      <div class="row">
        <div class="columns">
          <div class="column is-centered">
            <div class="box">
              <div class="columns is-left">
                <div class="column is-2 is-left" style="width:200px">
                  <div style="position:relative; display:inline-flex;">
                    <div style="cursor:pointer;" @click="redirect(jefe_admin.id)">
                      <b-image :src="getPhotoUrl(jefe_admin)" alt="Foto de perfil" style="max-width:150px; height:150px;" :rounded="true"></b-image>
                    </div>
                    <b-button
                      v-if="canEditAuthorities && jefe_admin.id"
                      style="position:absolute; bottom:4px; right:4px;"
                      size="is-small" type="is-info" rounded icon-left="camera"
                      @click.stop="abrirModalFoto(jefe_admin)"
                    />
                  </div>
                </div>
                <div class="column is-left">
                  <p class="title is-6" style="text-align:left; color:#A2A9AD;">{{jefe_admin.cargo}}</p>
                  <h4 class="subtitle is-5" style="text-align:left; color:#EF7D00;">{{jefe_admin.nombre}}</h4>
                  <h5 class="title is-6" style="text-align:left; color:#A2A9AD;">Correo Electrónico</h5>
                  <h5 class="subtitle is-6" style="text-align:left; color:#A2A9AD; word-break:break-all;">{{jefe_admin.correo}}</h5>
                  <div v-if="canEditAuthorities" class="mt-2">
                    <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion(jefe_admin)">Editar</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal asignar autoridad -->
    <b-modal v-model="editModal.active" has-modal-card trap-focus :destroy-on-hide="true">
      <modal-asignar-autoridad
        v-if="editModal.active"
        :cargo-label="editModal.cargoLabel"
        :persona-actual="editModal.personaActual"
        :function-options="editModal.functionOptions"
        :unit-id="editModal.unitId"
        @close="editModal.active = false"
        @saved="recargarAutoridades"
      />
    </b-modal>

    <!-- Modal editar foto -->
    <b-modal v-model="photoModal.active" has-modal-card trap-focus :destroy-on-hide="true">
      <modal-edit-profile-photo
        v-if="photoModal.active"
        :person="photoModal.person"
        :image="photoModal.image"
        @close="onPhotoModalClose"
      />
    </b-modal>

    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>


<script>
import axios from "axios";
import ModalAsignarAutoridad from "../faculty/modal_asignar_autoridad.vue";
import ModalEditProfilePhoto from "../person/modal_edit_profile_photo.vue";

export default {
  name: "authorities_list",
  components: { ModalAsignarAutoridad, ModalEditProfilePhoto },
  data() {
    return {
      isLoading:          false,
      director:           {},
      subdirectores:      [],
      jefes_carrera:      [],
      jefe_admin:         {},
      canEditAuthorities: false,
      editModal: {
        active:          false,
        cargoLabel:      "",
        personaActual:   null,
        functionOptions: [],
        unitId:          null,
      },
      photoModal: {
        active: false,
        person: null,
        image:  null,
      },
    };
  },
  created() {
    this.isLoading = true;
    axios.get("/admin/units/" + this.unitId + "/authorities.json")
      .then(res => {
        this.director          = res.data['director'];
        this.subdirectores     = res.data['subdirectores'];
        this.jefes_carrera     = res.data['jefes_carrera'];
        this.jefe_admin        = res.data['jefe_admin'];
        this.canEditAuthorities = res.data['can_edit_authorities'] || false;
        this.isLoading = false;
      })
      .catch(e => {
        this.isLoading = false;
        console.log(e);
      });
  },
  props: ['unitId'],
  methods: {
    verCargo(autoridad) {
      if (!autoridad) return false;
      if (autoridad.id != null) return true;
      return this.canEditAuthorities && autoridad.function_options && autoridad.function_options.length > 0;
    },
    redirect(id) {
      if (id === undefined || id === null) { return; }
      window.location.href = '/people/' + id;
    },
    getPhotoUrl(person) {
      if (person && person.photo_url) { return person.photo_url; }
      return "/blank_profile_photo.png";
    },
    abrirModalEdicion(autoridad) {
      if (!autoridad) return;
      this.editModal.cargoLabel      = autoridad.cargo || "";
      this.editModal.personaActual   = autoridad.nombre ? {
        nombre:             autoridad.nombre,
        person_function_id: autoridad.person_function_id,
        start_date:         autoridad.start_date,
      } : null;
      this.editModal.functionOptions = autoridad.function_options || [];
      this.editModal.unitId          = autoridad.unit_id || parseInt(this.unitId);
      this.editModal.active          = true;
    },
    abrirModalFoto(autoridad) {
      if (!autoridad || !autoridad.id) return;
      this.photoModal.person = { id: autoridad.id };
      this.photoModal.image  = autoridad.photo_url || null;
      this.photoModal.active = true;
    },
    onPhotoModalClose() {
      this.photoModal.active = false;
      this.recargarAutoridades();
    },
    recargarAutoridades() {
      this.isLoading = true;
      axios.get("/admin/units/" + this.unitId + "/authorities.json")
        .then(res => {
          this.director      = res.data['director'];
          this.subdirectores = res.data['subdirectores'];
          this.jefes_carrera = res.data['jefes_carrera'];
          this.jefe_admin    = res.data['jefe_admin'];
          this.isLoading     = false;
        })
        .catch(e => {
          this.isLoading = false;
          console.log(e);
        });
    },
  },
  computed: {},
};
</script>
